<template>
  <div class="pay">
    <div class="container-fluid">
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" href="#">代買幫付款</a>
      </nav>

      <!--  /////////////////////////////// -->
      <!-- <div class="title pt-3">付款方式</div> -->
      <div class="card">
        <div class="card-body">
          <div>
            <b>訂單資訊</b>
          </div>
          <div>訂單編號:{{ orderInfo.key }}</div>
          <div>商品價格:{{ Math.ceil(orderInfo.prod_price) }}台幣</div>
          <div>預估國際運費:{{ orderInfo.freight_price }}台幣</div>
          <!-- <div>發票手續費:{{Math.ceil(orderInfo.invoice_price)}}</div> -->
          <div v-if="walletInfo.hasOwnProperty('balance') == true">
            錢包點數:{{ walletInfo.balance }}點
          </div>
        </div>
      </div>
      <br />

      <div class="card">
        <div class="card-body">
          <div>
            <b>價格資訊</b>
          </div>

          <div v-if="!orderInfo.paymentv_account">
            <div
              v-if="
                walletInfo.hasOwnProperty('balance') == true &&
                parseInt(orderInfo.total) - parseInt(walletInfo.balance) >= 100
              "
            >
              <b>總共金額:{{ orderInfo.total }}台幣</b>
              <div style="font-size: 23px">
                <b
                  >扣除錢包後需付總共金額:{{
                    orderInfo.total - walletInfo.balance
                  }}台幣</b
                >
              </div>
            </div>
            <div
              v-if="
                walletInfo.hasOwnProperty('balance') == true &&
                parseInt(orderInfo.total) - parseInt(walletInfo.balance) <= 0
              "
            >
              <b>總共金額:{{ orderInfo.total }}台幣</b>
              <div style="font-size: 23px">
                <b
                  >扣除錢包後需付總共金額:{{
                    orderInfo.total - walletInfo.balance
                  }}台幣</b
                >
              </div>
            </div>
            <div
              v-else-if="
                walletInfo.hasOwnProperty('balance') == true &&
                parseInt(orderInfo.total) - parseInt(walletInfo.balance) <
                  100 &&
                parseInt(orderInfo.total) - parseInt(walletInfo.balance) > 0
              "
            >
              <b style="color: red"
                >由於第三方金流付款限制扣除錢包金額後低於100元，將不抵扣錢包金額!</b
              >
              <br />
              <div style="font-size: 23px">
                <b>總共金額:{{ orderInfo.total }}台幣</b>
              </div>
            </div>
          </div>
          <div v-else>
            <b>付款總金額:{{ orderInfo.payment_price }}台幣</b>
          </div>
        </div>
      </div>
      <br />
      <!-- <div class="card">
        <div class="card-body">
          <div style="float: left; display: block">
            <b>選擇付款銀行:</b>
          </div>
          <b-form-select
            v-model="atmPaymentSelected"
            :options="atmPaymentOptions"
          ></b-form-select>
        </div>
      </div> -->

      <div v-if="!orderInfo.paymentv_account">
        <br />
        <div v-if="orderInfo.status == 1 || orderInfo.status == 30">
          <!-- <button
            v-if="buttonActive"
            class="btn btn-danger btn-lg btn-block"
            @click="submit('ecpay')"
          >
            獲取付款資訊
          </button> -->
          <div
            v-if="
              walletInfo.hasOwnProperty('balance') == true &&
              parseInt(orderInfo.total) - parseInt(walletInfo.balance) <= 0
            "
          >
            <button
              v-if="buttonActive"
              class="btn btn-danger btn-lg btn-block"
              @click="walletDeduction(orderInfo.total)"
            >
              錢包直接扣款
            </button>
          </div>
          <div v-else>
            <button
              v-if="buttonActive"
              class="btn btn-danger btn-lg btn-block"
              @click="submit('smilepay')"
            >
              獲取付款資訊
            </button>
          </div>
        </div>
        <div v-else-if="buttonPayDone == true">
          <h5>錢包已扣款，付款完成!</h5>
        </div>
        <div v-else>
          <h5>訂單已經過期!</h5>
        </div>
      </div>
      <div v-else>
        <br />
        <div class="card">
          <div class="card-body">
            <h5 id="bankDiv">繳費資訊</h5>
            <!-- <div>繳費期限:{{orderInfo.expire_date}}</div> -->
            <div>繳費期限:今日</div>
            <!-- <div>交易編號:{{ orderInfo.payment_id }}</div> -->
            <div>繳費銀行代碼:{{ orderInfo.payment_bank_code }}</div>
            <div>繳費虛擬帳號:{{ orderInfo.paymentv_account }}</div>
            <br />
            <button
              class="btn btn-info btn-lg btn-block"
              v-clipboard:copy="orderInfo.paymentv_account"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              複製繳費虛擬帳號
            </button>
            <br />
          </div>
        </div>
      </div>

      <br />
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
    <v-dialog />
  </div>
</template>
<style type="text/css">
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.prod-block {
  /* background-color: #ff0000; */
}

.prod-text {
  /* overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 200px; */
}

.title {
  font-size: x-large;
  padding: 10px 0px;
}

.sale-price {
  color: #ff0000;
}

.noProd {
  font-size: 30px;
  color: red;
}

.padding-top-block {
  padding-top: 10px;
}

.calculation-text {
  font-size: 13px;
  color: red;
}

.w-400 {
  /* width: 100%;
  height: 200px; */
  height: 200px;
  width: 200px;
  width: 100%;
  /* object-fit: cover; */
  /* width: 400px;
  height: 500px; */
}
</style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
import { isMobile } from 'mobile-device-detect'

export default {
  name: 'pay',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      webhookApiUrl: process.env.VUE_APP_WEBHOOK_API_URL,
      displayViews: null,
      isLoading: true,
      checkMobile: isMobile ? '1' : '0',
      orderid: null,
      userId: null,
      orderInfo: {},
      walletInfo: {},
      atmPaymentSelected: 'CHINATRUST',
      buttonActive: false,
      atmPaymentOptions: [
        {
          value: null,
          text: '請選擇付款銀行',
        },
        //   {
        //     value: "TAISHIN",
        //     text: "台新"
        //   },
        //   {
        //     value: "ESUN",
        //     text: "玉山"
        //   },
        // {
        //   value: "BOT",
        //   text: "台灣銀行",
        // },
        // {
        //   value: "FUBON",
        //   text: "台北富邦"
        // },
        {
          value: 'CHINATRUST',
          text: '中國信託',
        },
        //   {
        //     value: "FIRST",
        //     text: "第一銀行"
        //   },
        //   {
        //     value: "LAND",
        //     text: "土地銀行"
        //   },
        // {
        //   value: "CATHAY",
        //   text: "國泰世華銀行",
        // },
        //   {
        //     value: "TACHONG",
        //     text: "大眾銀行"
        //   }
      ],
      buttonPayDone: false,
      totalAmountAfterCalculation: 0,
    }
  },
  methods: {
    onCopy: function () {
      const vm = this
      vm.$toast.open({
        message: '已幫您複製繳費虛擬帳號!',
        type: 'success',
      })
    },
    onError: function () {
      const vm = this
      vm.$toast.open({
        message: '複製失敗!',
        type: 'success',
      })
    },
    sendBidFbMessageConsumer: function (userId, order) {
      const vm = this

      ;(async function post() {
        let formData = {
          userId: userId,
          tempType: 'pay_atm',
          orderId: order.orderId,
          paymentId: order.paymentId,
          paymentBankCode: order.paymentBankCode,
          paymentvAccount: order.paymentvAccount,
          price: order.price,
        }
        await axios
          .post(vm.webhookApiUrl + 'SendMsgButtonTemplateV1.1', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function (response) {
            var data = response.data
            if (data.result == 'ok') {
              vm.$toast.open({
                message: '發送訊息!',
                type: 'success',
              })
            }
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '發送訊息失敗: ' + error,
              type: 'error',
            })
          })
      })()
    },
    checkUnChatbotSignin: function () {
      const vm = this

      try {
        if (
          vm.$route.query.userId ||
          vm.$route.query.userImage ||
          vm.$route.query.userName
        ) {
          localStorage.userId = decodeURI(vm.$route.query.userId)
          localStorage.userImage = decodeURI(vm.$route.query.userImage)
          localStorage.userName = decodeURI(vm.$route.query.userName)
          vm.userId = decodeURI(vm.$route.query.userId)
          vm.userImage = decodeURI(vm.$route.query.userImage)
          vm.userName = decodeURI(vm.$route.query.userName)
        }
      } catch (e) {
        // console.info(e);
        alert(e)
      }

      if (localStorage.userId == undefined) {
        vm.$modal.show('dialog', {
          title: '🙋您尚未登入FB會員',
          text: '請先登入才能使用此服務喔⚡',
          buttons: [
            {
              title: '👉用FB登入',
              handler: () => {
                window.location = 'https://m.me/2266831083395361'
              },
            },
          ],
        })
        // vm.$router.push("alibabaorder");
        return true
      } else {
        return false
      }
    },
    queryOrderByOrderId: function (order, sendmessage) {
      const vm = this

      if (order != null) {
        ;(async function post() {
          let formData = {
            orderId: order,
          }
          await axios
            .post(vm.apiUrl + 'QueryOrderByOrderId', formData, {
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
              },
            })
            .then(async function (response) {
              var data = response.data
              vm.orderInfo = data

              await vm.checkAccountExist(data.user_id)

              if (sendmessage) {
                //   var div = document.getElementById('bankDiv');
                //   div.scrollTop = div.scrollHeight;

                if (vm.orderInfo.paymentv_account != undefined) {
                  await vm.sendBidFbMessageConsumer(localStorage.userId, {
                    orderId: vm.orderInfo.key,
                    paymentId: vm.orderInfo.payment_id,
                    paymentBankCode: vm.orderInfo.payment_bank_code,
                    paymentvAccount: vm.orderInfo.paymentv_account,
                    price: vm.orderInfo.payment_price,
                  })
                } else {
                  vm.$toast.open({
                    message: '訂單錯誤，請再申請一次試試，或聯絡客服',
                    type: 'error',
                  })
                }
              }
              vm.isLoading = false
            })
            .catch(function (error) {
              // console.log(error);
              vm.$toast.open({
                message: '此訂單有誤: ' + error,
                type: 'error',
              })
            })
        })()
      }
    },
    queryWalletByUserId: function (userId) {
      const vm = this

      ;(async function post() {
        let formData = {
          userId: userId,
        }
        await axios
          .post(vm.apiUrl + 'QueryWalletByUserId', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(async function (response) {
            var data = response.data
            vm.walletInfo = data
            console.log('walletInfo:', vm.walletInfo)

            await vm.checkAccountExist(userId)

            vm.isLoading = false
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '錢包查詢失敗: ' + error,
              type: 'error',
            })
          })
      })()
    },
    updateWalletByUserId: function (userId, change) {
      const vm = this

      ;(async function post() {
        let formData = {
          userId: userId,
          change: change,
        }
        await axios
          .post(vm.apiUrl + 'UpdateWalletByUserId', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(async function (response) {
            var data = response.data
            // vm.walletInfo = data;
            console.log('walletInfo:', data)

            await vm.checkAccountExist(userId)

            vm.isLoading = false
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '更新失敗: ' + error,
              type: 'error',
            })
          })
      })()
    },
    updateOrderStatusByIdAndFbMessage: function (userId, orderId, status) {
      const vm = this

      ;(async function post() {
        let formData = {
          userId: userId,
          orderId: orderId,
          status: status,
        }
        await axios
          .post(vm.apiUrl + 'UpdateOrderStatusByIdAndFbMessage', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(async function (response) {
            var data = response.data
            // vm.walletInfo = data;
            console.log('updateOrderStatusByIdAndFbMessage:', data)

            await vm.checkAccountExist(userId)

            vm.isLoading = false
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '更新查詢失敗: ' + error,
              type: 'error',
            })
          })
      })()
    },
    submit: async function (paySw) {
      const vm = this

      await vm.queryOrderByOrderId(vm.orderid, false)

      let fqdn = 'PayATM'
      if (paySw == 'ecpay') {
        fqdn = 'PayATM'
      } else {
        fqdn = 'SmilePayATM'
      }

      if (vm.atmPaymentSelected != null) {
        vm.isLoading = true
        ;(async function post() {
          vm.$toast.open({
            message: '送出訂單中!!',
            type: 'success',
          })

          let formData = {
            orderId: vm.orderInfo.key,
            totalAmount: parseInt(vm.orderInfo.total),
            chooseSubPayment: vm.atmPaymentSelected,
          }

          // 修改為：加入 balance > 0 的條件
          if (
            vm.walletInfo.hasOwnProperty('balance') == true &&
            vm.walletInfo.balance > 0 &&
            parseInt(vm.orderInfo.total) - parseInt(vm.walletInfo.balance) >=
              100
          ) {
            // 使用錢包
            formData.totalAmount =
              parseInt(vm.orderInfo.total) - parseInt(vm.walletInfo.balance)

            let UpdateReadyUseWalletFormData = {
              userId: vm.userId,
              readyUse: 1,
            }

            await axios
              .post(
                vm.apiUrl + 'UpdateReadyUseWalletByUserId',
                UpdateReadyUseWalletFormData,
                {
                  headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                  },
                }
              )
              .then(function () {
                // var data = response.data;
                // vm.isLoading = false;
              })
              .catch(function (error) {
                // console.log(error);
                vm.$toast.open({
                  message: '此訂單有誤: ' + error,
                  type: 'error',
                })
              })
          } else {
            formData.totalAmount = parseInt(vm.orderInfo.total)
          }

          // //錢包扣掉後的總金額
          vm.totalAmountAfterCalculation = formData.totalAmount

          // vm.apiUrl
          console.log(vm.apiUrl + fqdn, formData)
          await axios
            .post(vm.apiUrl + fqdn, formData, {
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
              },
            })
            .then(function () {
              // var data = response.data;
              vm.$toast.open({
                message: '確認建立訂單中~ 請稍候2秒鐘...',
                type: 'success',
              })
              new Promise(resolve => setTimeout(resolve, 2000))
              ;(async function post() {
                await vm.queryOrderByOrderId(vm.orderInfo.key, true)
              })()
              // vm.isLoading = false;
            })
            .catch(function (error) {
              // console.log(error);
              vm.$toast.open({
                message: '此訂單有誤: ' + error,
                type: 'error',
              })
            })
        })()
      } else {
        vm.$toast.open({
          message: '請選擇付款方式',
          type: 'error',
        })
      }
    },
    checkAccountExist: function (userId) {
      const vm = this
      ;(async function post() {
        let formData = {
          userId: userId,
          isValid: 1,
        }
        await axios
          .post(vm.apiUrl + 'QueryProfile', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function (response) {
            var data = response.data
            if (data.length != 0) {
              // test
            } else {
              vm.$router.push(
                'identityverificationv1.1?accountNotExist=1&userId=' + userId
              )
            }
          })
          .catch(function () {
            vm.$router.push(
              'identityverificationv1.1?accountNotExist=1&userId=' + userId
            )
          })
      })()
    },
    walletDeduction: function (deduction) {
      const vm = this
      ;(async function post() {
        vm.isLoading = true
        // UpdateWalletByUserId
        await vm.updateWalletByUserId(vm.userId, Math.abs(deduction) * -1)
        // 通知付款成功
        await vm.updateOrderStatusByIdAndFbMessage(vm.userId, vm.orderid, 2)
        await vm.queryOrderByOrderId(vm.orderid, false)
        vm.buttonPayDone = true
        vm.isLoading = false
      })()
    },
  },
  watch: {},
  computed: {},
  mounted() {
    const vm = this
    vm.isLoading = true
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    vm.$toast.open({
      message: '資訊讀取中...',
      type: 'success',
    })

    // Event snippet for 進入機器人付款畫面 conversion page
    vm.$ga.event('event', 'conversion', {
      send_to: 'AW-700538278/h4xbCJi50bIBEKa7hc4C',
      value: 1.0,
      currency: 'TWD',
    })

    vm.checkUnChatbotSignin()

    vm.orderid = decodeURI(vm.$route.query.orderId)
    vm.userId = decodeURI(vm.$route.query.userId)
    vm.queryOrderByOrderId(vm.orderid, false)
    vm.queryWalletByUserId(vm.userId)

    setTimeout(function () {
      vm.$toast.open({
        message: '資訊讀取完成！！',
        type: 'success',
      })
      vm.buttonActive = true
    }, 4000)
  },
}
</script>
